import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";
import Select from "react-select";

const CourierServiceCostsForm = (props) => {
  const { errors, register, setValue, trigger, watch, deliveryPartners } = props;

  return (
    <Fragment>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">Courier</Label>
            <input type="hidden" {...register("delivery_partner_id")} />
            <Select
              placeholder="Select courier"
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              value={deliveryPartners.find((partner) => String(partner.id) === String(watch("delivery_partner_id"))) || null}
              onChange={(e) => {
                setValue("delivery_partner_id", e ? String(e.id) : "");
                trigger("delivery_partner_id");
              }}
              className={`${errors.delivery_partner_id ? "is-invalid" : ""}`}
              options={deliveryPartners}
            />
            <div className="invalid-feedback">{errors.delivery_partner_id?.message}</div>
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">Service Code</Label>
            <input name="service_code" type="text" maxLength={50} {...register("service_code")} className={`form-control ${errors.service_code ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.service_code?.message}</div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">Outbound Rate (£)</Label>
            <input name="outbound_rate" type="number" step="0.01" min="0" {...register("outbound_rate")} className={`form-control ${errors.outbound_rate ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.outbound_rate?.message}</div>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">Inbound Rate (£)</Label>
            <input name="inbound_rate" type="number" step="0.01" min="0" {...register("inbound_rate")} className={`form-control ${errors.inbound_rate ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.inbound_rate?.message}</div>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">Fuel %</Label>
            <input name="fuel_percentage" type="number" step="0.01" min="0" max="100" {...register("fuel_percentage")} className={`form-control ${errors.fuel_percentage ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.fuel_percentage?.message}</div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <small className="text-muted">
            <i className="fa fa-info-circle mr-1"></i>
            Fuel % is added on top of each rate: cost = rate × (1 + fuel % / 100). E.g. £5.00 with 10% fuel = £5.50.
          </small>
        </Col>
      </Row>
    </Fragment>
  );
};

export default CourierServiceCostsForm;
